export interface Environment {
  production: boolean;
  apiBaseUrl: string;
  strapiBaseUrl: string;
}

export const environment: Environment = {
  production: true,
  apiBaseUrl: 'https://together.fourenergy.de',
  strapiBaseUrl: 'https://strapi.together.fourenergy.de',
};
